export const parseBannerSlides = (value = "", linkUrl = "") => {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed) && parsed.length > 0) return parsed;
  } catch {}
  // Legacy: plain image URL stored as value
  return [{ image: value, link: linkUrl || "" }];
};
